import { ThunkType } from "../../../../core/store/reducers";
import deleteBankGuaranteeApi from "../api/deleteBankGuarantees";
import { setFetchState, invalidateBankGuarantee } from "../bankguaranteesDataSlice";

export const deleteBankGuarantee = (grntId: string): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = await dispatch(deleteBankGuaranteeApi(userId, grntId));

  dispatch(
    setFetchState(
      result !== undefined ? { type: "successful" } : { type: "error" }
    )
  );
  dispatch(invalidateBankGuarantee());
};
